import * as React from "react";
import { cn } from "@/lib/utils";

/* ENSSA Card — locked spec:
   - white surface, 8px radius, 1px subtle border, --sh-1 at rest
   - 24px internal padding (p-6)
   - NO top-stripe (marketing trope)
   - NO left-border accent (marketing trope)
   - NO gradient
   Hover lift via shadow-md only when component is genuinely
   interactive (e.g. clickable nav card); static stat cards stay flat.

   Phase 4 will pixel-diff this against legacy/Components.jsx <Card>
   before swapping any usage in. */

function Card({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card"
      className={cn(
        "bg-card text-card-foreground",
        // legacy parity: 10px radius, --border-subtle, --sh-1 shadow, 24px padding
        "rounded-[10px] border border-[var(--border-subtle)] shadow-[var(--sh-1)]",
        "p-6",
        className,
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card-header" className={cn("flex flex-col gap-1.5 pb-4", className)} {...props} />;
}

function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-title"
      className={cn("text-xl font-bold leading-snug text-foreground", className)}
      {...props}
    />
  );
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-description"
      className={cn("text-sm text-muted-foreground", className)}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card-content" className={cn("", className)} {...props} />;
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card-footer" className={cn("flex items-center pt-4", className)} {...props} />;
}

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
